<div class="encabezado">
  <div class="getBack" routerLink="/settings" style="cursor:pointer;">
    <i class="icon-arrow-left"></i>
    <span>{{ "buttons.back" | translate }}</span>
  </div>

  <h5 class="titulo1">
    <i class="icon-envelope"></i> {{ "settings.account_imap.title" | translate }}
  </h5>
  <p class="subtitle">{{ "settings.account_imap.description" | translate }}</p>

  <!-- Loading -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Form -->
  <div class="imap-form-container" *ngIf="!isLoading">
    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="row">
        <!-- Host -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label">{{ "settings.account_imap.host" | translate }} *</label>
          <input type="text" class="form-control" formControlName="host"
            placeholder="imap.example.com"
            [class.is-invalid]="isFieldInvalid('host')">
          <div class="invalid-feedback" *ngIf="isFieldInvalid('host')">
            {{ "swal_messages.general.required" | translate }}
          </div>
        </div>

        <!-- Port -->
        <div class="col-6 col-md-3 mb-3">
          <label class="form-label">{{ "settings.account_imap.port" | translate }} *</label>
          <input type="number" class="form-control" formControlName="port"
            [class.is-invalid]="isFieldInvalid('port')">
          <div class="invalid-feedback" *ngIf="isFieldInvalid('port')">
            {{ "swal_messages.general.required" | translate }}
          </div>
        </div>

        <!-- Encryption -->
        <div class="col-6 col-md-3 mb-3">
          <label class="form-label">{{ "settings.account_imap.encryption" | translate }}</label>
          <select class="form-control" formControlName="encryption">
            <option *ngFor="let opt of encryptionOptions" [ngValue]="opt.value">
              {{ opt.value ? opt.label : (opt.label | translate) }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <!-- Username -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label">{{ "settings.account_imap.username" | translate }} *</label>
          <input type="text" class="form-control" formControlName="username"
            placeholder="ventas@miempresa.com"
            [class.is-invalid]="isFieldInvalid('username')">
          <div class="invalid-feedback" *ngIf="isFieldInvalid('username')">
            {{ "swal_messages.general.required" | translate }}
          </div>
        </div>

        <!-- Password -->
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label">
            {{ "settings.account_imap.password" | translate }}
            <span *ngIf="isNew">*</span>
          </label>
          <input type="password" class="form-control" formControlName="password"
            [placeholder]="isNew ? '' : ('settings.account_imap.password_placeholder' | translate)"
            [class.is-invalid]="isFieldInvalid('password')">
          <div class="invalid-feedback" *ngIf="isFieldInvalid('password')">
            {{ "swal_messages.general.required" | translate }}
          </div>
          <small class="text-muted" *ngIf="!isNew">{{ "settings.account_imap.password_hint" | translate }}</small>
        </div>
      </div>

      <div class="row">
        <!-- Validate cert -->
        <div class="col-12 mb-3">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="validateCert" formControlName="validate_cert">
            <label class="form-check-label" for="validateCert">
              {{ "settings.account_imap.validate_cert" | translate }}
            </label>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="isSaving">
          <i [class]="isSaving ? 'spinner-border spinner-border-sm' : 'icon-check'"></i>
          {{ (isNew ? "settings.account_imap.create" : "settings.account_imap.update") | translate }}
        </button>

        <button type="button" class="btn btn-secundario" (click)="testConnection()" [disabled]="isTesting">
          <i [class]="isTesting ? 'spinner-border spinner-border-sm' : 'icon-connection'"></i>
          {{ "settings.account_imap.test_connection" | translate }}
        </button>

        <button type="button" class="btn btn-outline-danger" *ngIf="!isNew" (click)="deleteConfig()" [disabled]="isDeleting">
          <i [class]="isDeleting ? 'spinner-border spinner-border-sm' : 'icon-trash'"></i>
          {{ "settings.account_imap.delete" | translate }}
        </button>
      </div>

      <!-- Test result -->
      <div class="test-result mt-3" *ngIf="testResult">
        <div class="alert" [class.alert-success]="testResult === 'success'" [class.alert-danger]="testResult === 'error'">
          <i [class]="testResult === 'success' ? 'icon-checkmark-circle' : 'icon-warning'"></i>
          {{ (testResult === 'success' ? "settings.account_imap.connection_ok" : "settings.account_imap.connection_failed") | translate }}
        </div>
      </div>
    </form>
  </div>
</div>
